export var wishlistItem = function wishlistItem(data) {
  var wishlistData = JSON.parse(localStorage.getItem('wishlist') || null);
  if (!wishlistData) {
    return 0;
  }
  var prodId = data;
  return wishlistData.items.some(function (item) {
    return item.id === prodId;
  }) ? 1 : 0;
};